<template>
  <div
    v-if="highlightArticleData"
    class="product-box-wide__personalization-banner-wrapper product-box-wide__highlight-article-wrapper"
  >
    <div class="product-box-wide__highlight-article-badge">
      <div
        v-if="highlightArticleData.text"
        v-html="highlightArticleData.text"
        class="product-box-wide__highlight-article-text"
      />
      <img
        v-if="highlightArticleData.icon"
        class="product-box-wide__highlight-article-icon"
        :src="highlightArticleData.icon"
        alt=""
        aria-hidden="true"
      >
    </div>
  </div>
  <div
    v-else-if="settings.personalisationTop && productBoxData.personalPreferenceMessageKey"
    class="product-box-wide__personalization-banner-wrapper"
  >
    <div
      class="product-box-wide__personalization-banner personalization-banner"
      v-html="t(productBoxData.personalPreferenceMessageKey)"
    />
  </div>
</template>
<script setup lang="ts">
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import {ProductBoxWideSettings} from './productBoxWideSettings';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';

  const props = defineProps<{
    productBoxData: ProductBoxData;
    settings: ProductBoxWideSettings;
  }>();

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);
</script>
